import { render, staticRenderFns } from "./profileCertificates.vue?vue&type=template&id=189532f9"
import script from "./profileCertificates.vue?vue&type=script&lang=js"
export * from "./profileCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports